import { motion } from 'framer-motion';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/886a903f46e54eb7ea1c7f801303bb12.jpg"
          alt="Professional paintless dent repair service in Kansas City"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 py-32 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="font-montserrat font-bold text-5xl md:text-6xl lg:text-7xl text-white leading-tight mb-6">
            Paintless Dent Repair in<br />Kansas City — Done Right
          </h1>
          <p className="font-inter text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed">
            Fast turnaround • Preserve factory finish • Insurance-friendly<br />
            No paint, no fillers — just expert craftsmanship
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-primary hover:bg-[#e67028] text-white font-montserrat font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get a Free Estimate
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="bg-transparent border-2 border-secondary hover:border-secondary-dark hover:bg-secondary/10 text-white font-montserrat font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Our Work
            </button>
          </div>
        </motion.div>

        {/* Trust Bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8"
        >
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/20 rounded-full mb-3">
              <i className="ri-time-line text-3xl text-primary"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-1">30+ Years of Combined Experience</h3>
            <p className="font-inter text-sm text-white/80">Trusted expertise</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center bg-secondary/20 rounded-full mb-3">
              <i className="ri-shield-check-line text-3xl text-secondary"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-1">Honest Estimates</h3>
            <p className="font-inter text-sm text-white/80">No hidden fees</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center bg-primary/20 rounded-full mb-3">
              <i className="ri-flashlight-line text-3xl text-primary"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-1">Fast Turnaround</h3>
            <p className="font-inter text-sm text-white/80">Quick service</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-16 h-16 flex items-center justify-center bg-secondary/20 rounded-full mb-3">
              <i className="ri-paint-brush-line text-3xl text-secondary"></i>
            </div>
            <h3 className="font-montserrat font-semibold text-white text-lg mb-1">Preserve Factory Finish</h3>
            <p className="font-inter text-sm text-white/80">No repainting</p>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </motion.div>
    </section>
  );
}
